import React from 'react';
import styled from 'styled-components';
import { AiWord, AiBall, AiCross } from 'images/aiMarketingCaseStudy';
import { AgencyXLogo } from 'images/shared';
import { useWindowSize } from 'hooks';
import { RenderWhenReady } from 'components';
import { motion } from 'framer-motion';
import { Link } from 'gatsby';

const StartYourJourney = () => {
  const { windowWidth } = useWindowSize();
  return (
    <Container
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}>
      <RenderWhenReady>
      {windowWidth > 768 && (
        <>
          <AnimatedSVG
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}>
            <AiWord color="#0F88C1" />
          </AnimatedSVG>
          <AnimatedSVG
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}>
            <AiBall primaryColor="#CE9200" secondaryColor="#47AD4A" />
          </AnimatedSVG>
          <AnimatedSVG
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}>
            <AiCross color="#DA629E" />
          </AnimatedSVG>
        </>
      )}
      </RenderWhenReady>
      <AgencyXLogo style={{ maxWidth: '242px' }} />
      <p>Start your campaign journey with us</p>
      <button type="button">
        <Link to="/contact" id="contact-us-omnichannel">Contact Us</Link>
      </button>
    </Container>
  );
};

export const AnimatedSVG = styled(motion.div)`
  @keyframes roll {
    0% {
      transform: translateX(0) rotate(0deg);
    }
    50% {
      transform: translateX(-100px) rotate(-60deg);
    }
    100% {
      transform: translateX(0) rotate(0deg);
    }
  }
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(25deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
`;

const Container = styled.div`
  align-items: center;
  background: rgba(255, 255, 255, 0.6);
  display: flex;
  flex-direction: column;
  gap: 1.325rem;
  height: auto;
  padding: 2.5rem 2rem;
  position: relative;
  text-align: center;
  transition: 0.75s;
  width: 100%;

  @media (min-width: 1150px) {
    padding: 2.5rem 3rem;
  }

  ${AnimatedSVG} {
    position: absolute;
    z-index: 1;
    transition-duration: 0.75s;
    transition-delay: 0.75s;
    :nth-child(1) {
      top: -40px;
      right: -40px;
      width: 120px;
    }
    :nth-child(2) {
      bottom: -70px;
      right: -70px;
      width: 170px;
      svg {
        animation: roll 3s ease-in-out infinite alternate-reverse;
      }
    }
    :nth-child(3) {
      bottom: -20px;
      left: -20px;
      width: 80px;
      svg {
        animation: spin 2s 1s ease-in-out infinite alternate-reverse;
      }
    }
  }
  h2 {
    margin-bottom: 1rem;
    text-transform: uppercase;
    color: var(--ax-gold);
  }
  p {
    font-size: 1.5rem;
    line-height: 1.25em;
    color: black;
    font-weight: 300;
    max-width: 800px;
    @media (min-width: 1150px) {
      font-size: 2rem;
      line-height: 1.5em;
    }
  }
  button {
    width: 166px;
    height: 46px;
    font-size: 16px;
    line-height: 19px;
    background: var(--ax-gold);
    color: white;
    text-transform: uppercase;
    font-weight: 700;
    margin-bottom: 0;
    transition: 0.375s;
    cursor: pointer;
    &:hover,
    &:focus {
      border: none;
      outline: none;
      background: var(--ax-black);
    }
    a {
      color: white;
      height: 100%;
      width: 100%;
      text-decoration: none;
    }
  }
`;

export default StartYourJourney;
